import CheckboxPR from "./CheckboxPR";

export default CheckboxPR;
